import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "@gravity-ui/uikit";
import { PlaceCardShort } from "@/components/ui/PlaceCard";
export var PlacesList = function (props) {
    return (_jsx(Flex, { direction: "column", gap: 3, children: props.data.items.map(function (el) { return (_jsx(PlaceCardShort, { place: el, onDetailsClick: props.onDetailsClick }, el.id)); }) }));
};
